import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './Layout/Header';
import Home from './Pages/Home';
import Footer from './Layout/Footer';
import Services from './Pages/Services';
import About from './Pages/About'

import ScrollToTop from './Components/ScrollToTop';
import Imprint from './Pages/Imprint';
import CookiePolicy from './Pages/CookiePolicy';
import CookieBanner from './Layout/CookieBanner';
import Privacy from './Pages/Privacy';
import Layout from './Layout/Layout';
//import DateButton from './Components/DateButton';
import WhatsAppButton from './Components/WhatsAppButton';
import Contact from './Pages/Contact';
import InstagramButton from './Components/InstagramButton';

function App() {
  return (
<Router>
  <Layout>
    <AnimatePresence mode="wait">
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/cookiepolicy" element={<CookiePolicy />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    <WhatsAppButton></WhatsAppButton>
    <InstagramButton></InstagramButton>
    </AnimatePresence>
  </Layout>
</Router>
  );
}

export default App;